Vue.asyncComponent('cms-active-workspace-logo', {
    props: {
        maxHeight: {
            type: [String, Number],
        },
        maxWidth: {
            type: [String, Number],
        },
        horizontalAlignment: {
            type: String,
            default: 'center',
        },
        verticalAlignment: {
            type: String,
            default: 'center',
        },
    },
    computed: {
        logo() {
            return this.$userInterfaceHandler.getUserInterface()?.workspace.logo ?
                    this.$userInterfaceHandler.getUserInterface()?.workspace.logo:
                    this.$getSetting('assets.logo');
        },
        title() {
            return this.$userInterfaceHandler.getUserInterface()?.workspace.title ?
                    this.$userInterfaceHandler.getUserInterface()?.workspace.title:
                    null;
        },
        normalizedMaxHeight() {
            return this.normalizePixelValue(this.maxHeight);
        },
        normalizedMaxWidth() {
            return this.normalizePixelValue(this.maxWidth);
        },
        wrapperStyle() {
            const justifyContentMap = {
                left: 'flex-start',
                center: 'center',
                right: 'flex-end',
            };
            const alignItemsMap = {
                top: 'flex-start',
                center: 'center',
                bottom: 'flex-end',
            };

            return {
                justifyContent: justifyContentMap[this.horizontalAlignment] || 'center',
                alignItems: alignItemsMap[this.verticalAlignment] || 'center',
            };
        },
        alignmentClasses() {
            return [
                `cms-active-workspace-logo__wrapper--horizontal-${this.horizontalAlignment}`,
                `cms-active-workspace-logo__wrapper--vertical-${this.verticalAlignment}`,
            ];
        }
    },
    methods: {
        normalizePixelValue(value) {
            if (value === null || typeof value === 'undefined' || value === '') {
                return null;
            }

            if (typeof value === 'number') {
                return `${value}px`;
            }

            return /^\d+$/.test(value)
                ? `${value}px`
                : value;
        }
    }
}, 'cms/layout/cms-active-workspace-logo.html');
